var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"bottom":"","disabled":!_vm.showTooltip,"color":"rgba(0, 0, 0, 1)"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({attrs:{"data-test":_vm.event.status}},'span',attrs,false),on),[(_vm.alwaysShow || _vm.event.status != 'registration_open')?_c('span',{class:[
          _vm.texts[_vm.event.status].color,
          'chip',
          _vm.block ? 'chip-block' : ' px-2',
          _vm.border ? 'border' : '',
          _vm.large ? 'large-chip' : ''
        ]},[_vm._v("\n        "+_vm._s(_vm.texts[_vm.event.status].text)+"\n        "),(_vm.showLockIcon || _vm.showClockIcon)?_c('v-icon',{staticStyle:{"font-size":"12px"},attrs:{"color":"black","right":""}},[_vm._v("\n          "+_vm._s(_vm.showClockIcon ? "$iconClock" : "$iconLock")+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.event.unlisted)?_c('v-icon',{staticStyle:{"font-size":"12px"},attrs:{"color":"black","right":""}},[_vm._v("\n          $iconEyeSlash\n        ")]):_vm._e()],1):(!_vm.noButton)?[_c('AppShowRegistrationBtn',{staticClass:"d-print-none",attrs:{"event":_vm.event}}),_vm._v(" "),_c('div',{staticClass:"d-none d-print-block"},[_vm._v("\n          "+_vm._s(_vm.$t("common:button.register", "Register", "Register button"))+"\n          "+_vm._s(_vm.$t(
              "common:register.until.label",
              "Until:",
              "Register butten label Until:"
            ))+"\n          "+_vm._s(_vm.$dayjs.date(_vm.event.registrationEndDate))+"\n        ")])]:_vm._e()],2)]}}])},[_vm._v(" "),_c('span',[(
        _vm.event.status == 'cancelled' &&
        _vm.event.cancelReasonId &&
        _vm.event.cancelReason
      )?[_vm._v("\n      "+_vm._s(_vm.event.cancelReason.name)+"\n    ")]:(_vm.event.publicRegistrationOpensFrom)?[_vm._v("\n      "+_vm._s(_vm.$t(
          [
            "events:eventStatus.publicRegistrationOpensFrom.tooltip",
            "Open for entries from: {\{publicRegistrationOpensFrom}\}"
          ],
          {
            publicRegistrationOpensFrom: _vm.$dayjs.date(
              _vm.event.publicRegistrationOpensFrom
            ),
            interpolation: { escapeValue: false }
          }
        ))+"\n    ")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }